import * as React from 'react'

import { cn } from '@/lib/utils'

function Input({
  className,
  mainClassName,
  type,
  prefixIcon: startIcon,
  suffixIcon: endIcon,
  ...props
}: React.ComponentProps<'input'> & {
  mainClassName?: React.ComponentProps<'div'>['className']
  prefixIcon?: React.ReactNode
  suffixIcon?: React.ReactNode
}) {
  return (
    <div
      className={cn(
        'bg-secondary/70 relative w-full rounded-md backdrop-blur-sm',
        mainClassName
      )}
    >
      {startIcon && (
        <div className="absolute top-1/2 left-3 -translate-y-1/2 transform">
          {startIcon}
        </div>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-12 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-sm shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:ring-primary/20 focus-visible:border-transparent focus-visible:ring-[2px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          startIcon ? 'pl-10' : '',
          endIcon ? 'pr-10' : '',
          'disabled:bg-[#d5d5d5] disabled:opacity-60',
          className
        )}
        {...props}
      />
      {endIcon && (
        <div className="absolute top-1/2 right-3 flex -translate-y-1/2 transform items-center">
          {endIcon}
        </div>
      )}
    </div>
  )
}

export { Input }
